<template>
    <div>

    <SolicitarApoyoEscolar
        v-if="mostrarFormulario"
        :tiene_apoyo_trabajador="tiene_apoyo_trabajador"
        :datos_empleado="datosEmpleadoFormulario"
        :id_apoyo_escolar="idApoyoEscolarEditar"
        :datos_apoyo_escolar_editar="apoyoEscolarEditar"
        :observaciones="observaciones"
        :configuracion_apoyos_tipo_trabajador="configuracion_apoyos_tipo_trabajador"
        :conteo_apoyos_por_tipo="conteo_apoyos_por_tipo"
        @regresar="manejarRegresarFormulario"
    />

    <v-container fluid tag="section" class="mt-4 bg-white border rounded shadow apoyos-escolares-page" v-else-if="datos_empleado.id_tipo_trabajador != 4 && datos_empleado.id_tipo_trabajador != 3 && datos_empleado != null && id_estado_empleado != 3 && id_estado_empleado != 8 && datos_empleado.esta_en_proceso_administrativo != true && datos_empleado.ya_tiene_la_antiguedad_requerida != false">

          <v-row justify="center">
            <v-row>
                <v-col cols="12" class="text-center mb-2" v-if="!loading">
                    <template v-if="datos_periodo_apoyo_escolar_activo">
                        <h4 class="mb-1">
                            NOMBRE DEL PERIODO: {{ datos_periodo_apoyo_escolar_activo.descripcion }}
                        </h4>

                        <p class="mb-0">
                            FECHA DEL PERIODO:
                            {{ datos_periodo_apoyo_escolar_activo.fecha_inicio }}
                            -
                            {{ datos_periodo_apoyo_escolar_activo.fecha_fin }}
                        </p>
                        <p
                            v-if="captura_apoyo_escolar && captura_apoyo_escolar.tiene_extension && captura_apoyo_escolar.puede"
                            class="mb-0 mt-1"
                        >
                            TIENES UNA FECHA EXTENDIDA DE CAPTURA:
                            <b>{{ captura_apoyo_escolar.fecha_limite_efectiva }}</b>
                        </p>
                        <p
                            v-else-if="captura_apoyo_escolar && captura_apoyo_escolar.motivo && !captura_apoyo_escolar.puede"
                            class="mb-0 mt-1 text--secondary"
                        >
                            {{ captura_apoyo_escolar.mensaje || 'El periodo de captura no está disponible.' }}
                        </p>
                    </template>

                    <h4 v-else class="mb-1">
                        NO HAY PERIODO ACTIVO DE APOYOS ESCOLARES
                    </h4>
                </v-col>
                <!-- Botón para abrir el modal -->
                <v-col cols="12" sm="6" v-if="puedeSolicitarApoyoEscolar">
                    <v-btn
                        color="primary"
                        block
                        class="text-caption text-sm-body-2"
                        @click="solicitarApoyoEscolarVista()"

                    >   
                        <v-icon start>mdi-plus</v-icon>
                        <span class="d-none d-sm-inline">SOLICITAR APOYO ESCOLAR</span>
                    </v-btn>
                </v-col>
            </v-row>
              <v-row >
                <v-col cols="12" class="d-flex justify-center align-center apoyos-escolares-loading" v-if="loading">
                    <v-progress-circular
                        indeterminate
                        color="primary"
                        size="100"
                    />
                </v-col>

                  <v-col v-else-if="showTable" cols="12" sm="12">
                      <v-client-table :data="dataApoyosEscolares" :columns="columns" :options="options">
                          <template slot="estatus" slot-scope="props">
                              <span v-if="props.row.estatus_id==1" class="badge bg-warning text-dark">
                                  {{ props.row.estatus }}
                              </span>
                              <span v-if="props.row.estatus_id==2" class="badge bg-success">
                                  {{ props.row.estatus }}
                              </span>
                              <span v-if="props.row.estatus_id==3" class="badge bg-danger">
                                  {{ props.row.estatus }}
                              </span>
                          </template>
                          <template slot="acciones" slot-scope="props">
                              <v-menu bottom right>
                                  <template v-if="props.row.estatus_id !=1" v-slot:activator="{ on, attrs }">
                                      <v-btn icon v-bind="attrs" v-on="on">
                                          <v-icon>mdi-dots-vertical</v-icon>
                                      </v-btn>
                                  </template>
                                  <v-list>
                                      <v-list-item v-if="props.row.estatus_id==2" @click="generar_acuse_apoyo_escolar(props.row)">
                                          <v-list-item-icon>
                                              <v-icon class="text-info">mdi-eye</v-icon>
                                          </v-list-item-icon>
                                          <v-list-item-title>GENERAR ACUSE</v-list-item-title>
                                      </v-list-item>
                                      <v-list-item v-if="props.row.estatus_id==3" @click="editar_apoyo_escolar(props.row)">
                                          <v-list-item-icon>
                                              <v-icon class="text-warning">mdi-pencil</v-icon>
                                          </v-list-item-icon>
                                          <v-list-item-title>MODIFICAR</v-list-item-title>
                                      </v-list-item>
                                  </v-list>
                              </v-menu>
                          </template>
                      </v-client-table>
                  </v-col>
              </v-row>


          </v-row>


            <v-snackbar
                v-model="snackbar.show"
                :color="snackbar.color"
                timeout="3000"
                >
                {{ snackbar.text }}
            </v-snackbar>

    </v-container>
    <v-container fluid tag="section" class="mt-4 bg-white border rounded shadow text-center apoyos-escolares-page" v-else>
      <h2 class="title">Acceso restringido</h2>
      <p class="subtitle">No tienes permisos para acceder a esta sección.</p>
    </v-container>

        </div>

</template>
<script>
import { mapState } from 'vuex'
import ModalEspera from "./ModalWait.vue";
import SolicitarApoyoEscolar from './Solicitar_apoyo_escolar.vue';

export default {
    components: {
        ModalEspera,
        SolicitarApoyoEscolar
    },
    data:function(){
        return {
            mostrarFormulario:false,
            idApoyoEscolarEditar: null,
            apoyoEscolarEditar: null,
            observaciones: null,
            loading: true,
            userData : [],
            dataApoyosEscolares : [],
            mostrar_tabla_empleado : false,
            showTable :false,
            columns: ['folio', 'nombre_beneficiario','tipo_solicitante', 'nivel_escolar','anio','semestre','fecha_vigencia', 'estatus','acciones'],
            options: {
                headings: {
                    folio: 'FOLIO',
                    nombre_beneficiario: 'NOMBRE BENEFICIARIO',
                    tipo_solicitante: 'TIPO BENEFICIARIO',
                    nivel_escolar: 'NIVEL ESCOLAR',
                    anio: 'AÑO',
                    semestre: 'SEMESTRE',
                    fecha_vigencia: 'FECHA VIGENCIA',
                    estatus: 'ESTATUS',
                    acciones: 'ACCIONES'

                },
                sortable: ['folio', 'nombre_beneficiario', 'tipo_solicitante', 'nivel_escolar', 'anio', 'semestre', 'fecha_vigencia', 'estatus', 'acciones'],
                texts: {
                    count:"Mostrando del {from} al {to} de {count} registros|{count} resultados|1 resultado",
                    filter:"Buscar:",
                    filterPlaceholder: 'Buscar...',
                    limit:"Resultados:",
                    recordsDisplay: 'Resultados',
                    page:"Página:",
                    noResults:"No hay resultados",
                    filterBy: 'Buscar...',
                    loading:'Cargando...',
                    defaultOption: 'Seleccionar {column}'
                },
                filterable: true,
                filterByColumn: false,
                resizableColumns: false,
                sendEmptyFilters :false,
                childRowTogglerFirst: true,
                showChildRowToggler: true,
                perPage: 5,
                perPageValues: [5, 10, 15, 20],
                filterable: ['folio', 'nombre_beneficiario', 'tipo_solicitante', 'nivel_escolar','anio','semestre', 'fecha_vigencia', 'estatus'],
                    templates: {

                    }, filterByColumn: true,
            },

            //modal subir documentos
            showModal: false,
            titulo_modal: '',
            ticket: '',
            respuesta_ticket: '',
            tipo_accion_modal_ticket: 'GUARDAR', // GUARDAR, EDITAR, VER
            es_subir_archivo: false,
            datos_empleado: [],
            numero_apoyos_empleado_con_fecha_vigente: null,
            tiene_apoyo_trabajador: null,
            configuracion_apoyos_tipo_trabajador: {
                max_solicitudes_trabajador: 0,
                max_solicitudes_hijo: 0,
            },
            conteo_apoyos_por_tipo: {
                trabajador: 0,
                hijo: 0,
            },
            id_estado_empleado: null,
            datos_periodo_apoyo_escolar_activo: false,
            captura_apoyo_escolar: null,

            // Dropbox component data
            isDragging: false,
            files: [],
            isUploading: false,
            snackbar: {
                show: false,
                text: '',
                color: 'success'
            },
        }
    },
    computed:{
        ...mapState(["user"]),
        ...mapState(["token"]),
        ...mapState(["baseUrl"]),
        datosEmpleadoFormulario(){
            return {
                id_empleado: this.datos_empleado.id_empleado || null,
                nombre: this.datos_empleado.nombre || '',
                ap_paterno: this.datos_empleado.ap_paterno || '',
				ap_materno: this.datos_empleado.ap_materno || '',
				curp: this.datos_empleado.curp || ''
            };
        },
        puedeSolicitarApoyoEscolar(){
            if (!this.datos_periodo_apoyo_escolar_activo) {
                return false;
            }

            if (this.captura_apoyo_escolar && this.captura_apoyo_escolar.puede === false) {
                return false;
            }

            const maxTrabajador = Number(this.configuracion_apoyos_tipo_trabajador.max_solicitudes_trabajador || 0);
            const maxHijo = Number(this.configuracion_apoyos_tipo_trabajador.max_solicitudes_hijo || 0);
            const totalTrabajador = Number(this.conteo_apoyos_por_tipo.trabajador || 0);
            const totalHijo = Number(this.conteo_apoyos_por_tipo.hijo || 0);

            return totalTrabajador < maxTrabajador || totalHijo < maxHijo;
        },
    },
    async mounted(){
        await this.obtener_datos_empleado();
        if(this.datos_empleado.id_tipo_trabajador != 4){
        }
        await this.getApoyosEscolaresEmpleado();
    },
    methods: {
        generar_acuse_apoyo_escolar(row){
            const form = document.createElement('form');
            form.target = '_blank';
            form.method = 'post';
            form.id = 'form-acuse-apoyo-escolar';
            form.action = `${this.baseUrl}post-empleado-apoyos-escolares-acuse?token=${this.token}`;

            const idApoyoEscolar = document.createElement('input');
            idApoyoEscolar.type = 'hidden';
            idApoyoEscolar.name = 'id_apoyo_escolar';
            idApoyoEscolar.value = row.id_apoyo_escolar;
            form.append(idApoyoEscolar);

            document.body.append(form);
            form.submit();
            document.body.removeChild(form);
        },
        editar_apoyo_escolar(row){
            this.tiene_apoyo_trabajador = false;
            this.idApoyoEscolarEditar = row.id_apoyo_escolar;
            this.apoyoEscolarEditar = {
                id_apoyo_escolar: row.id_apoyo_escolar,
                folio: row.folio,
                nombre: row.nombre,
                ap_paterno: row.ap_paterno,
                ap_materno: row.ap_materno,
                curp: row.curp,
                tipo_solicitante: row.tipo_solicitante,
                nivel_escolar: row.nivel_escolar,
                parentesco: row.parentesco,
                cumple_promedio: row.cumple_promedio,
                promedio_ultimo_ciclo: row.promedio_ultimo_ciclo,
                observaciones: row.observaciones,
            };
            this.mostrarFormulario = true;
            this.observaciones = row.observaciones;
        },
        async getApoyosEscolaresEmpleado(){
            try{
                //peticion de la datatable
                 let response = await this.$http.get("get-apoyos-escolares/"+this.user.id_empleado);
               //DATOS PARA LA TABLA
                this.dataApoyosEscolares = Array.isArray(response.data.data.activos) ? response.data.data.activos : [];
                //DATOS PARA VALIDACIONES PARA MANEJAR LOS BOTONES DE SOLICITUD DE APOYO ESCOLAR Y BOTONES DE ACCIONES
                this.numero_apoyos_empleado_con_fecha_vigente = response.data.data.numero_apoyos_empleado_con_fecha_vigente;
                this.tiene_apoyo_trabajador = response.data.data.tiene_apoyo_trabajador;
                this.configuracion_apoyos_tipo_trabajador = response.data.data.configuracion_tipo_trabajador || {
                    max_solicitudes_trabajador: 0,
                    max_solicitudes_hijo: 0,
                };
                this.conteo_apoyos_por_tipo = response.data.data.conteo_apoyos_por_tipo || {
                    trabajador: 0,
                    hijo: 0,
                };
                this.datos_periodo_apoyo_escolar_activo = response.data.data.datos_periodo_apoyo_escolar_activo;
                this.captura_apoyo_escolar = response.data.data.captura_apoyo_escolar || null;
                this.id_estado_empleado = response.data.data.id_estado_empleado;

                this.showTable = true
                this.loading = false;
            }catch(error){

            }
        },

        //Abre la vista para solicitar apoyo escolar
        solicitarApoyoEscolarVista() {
            this.idApoyoEscolarEditar = null;
            this.apoyoEscolarEditar = null;
            this.observaciones = null;
            this.mostrarFormulario = true;
        },
        async manejarRegresarFormulario(payload = {}) {
            const solicitudExitosa = payload && payload.solicitudExitosa === true;

            this.mostrarFormulario = false;
            this.idApoyoEscolarEditar = null;
            this.apoyoEscolarEditar = null;
            this.numero_apoyos_empleado_con_fecha_vigente = null;
            this.datos_periodo_apoyo_escolar_activo = false;
            this.captura_apoyo_escolar = null;
            this.tiene_apoyo_trabajador = null;
            this.configuracion_apoyos_tipo_trabajador = {
                max_solicitudes_trabajador: 0,
                max_solicitudes_hijo: 0,
            };
            this.conteo_apoyos_por_tipo = {
                trabajador: 0,
                hijo: 0,
            };
            this.observaciones = null;
            this.loading = true;
            this.showTable = false;
            this.id_estado_empleado = null;
            await this.getApoyosEscolaresEmpleado();

            if (solicitudExitosa) {
                this.mostrarMensajeSolicitudExitosa();
            }
        },
        mostrarMensajeSolicitudExitosa() {
            this.$swal({
                content: {
                    element: 'div',
                    attributes: {
                        innerHTML: `
                            <div class="swal-content" style="text-align: left; font-size: 14px; margin-top: 15px;">
                                <p style="margin-bottom: 12px;">
                                    Le informamos que la documentación que cargó en el sistema se encuentra actualmente en proceso de revisión y en un plazo máximo de tres días hábiles, recibirá una notificación a través de su correo electrónico, en la que se le informará el resultado de:
                                </p>
                                <p style="margin-bottom: 12px;">
                                    <strong>Procedente</strong><br>
                                    Se le informará por correo electrónico cuando pueda descargar su Acuse de recepción de su documentación.
                                </p>
                                <p style="margin-bottom: 12px;">
                                    <strong>No procedente</strong><br>
                                    En caso de que se detecte que la documentación esta incompleta, ilegible, no vigente u otra observación, se le hará llegar a su correo en un término de tres días hábiles.
                                </p>
                                <p style="margin-bottom: 0;">
                                    Le invitamos a mantenerse pendiente de su correo electrónico para cualquier comunicación con este proceso.
                                </p>
                            </div>
                        `
                    }
                },
                icon: 'info',
                button: 'Aceptar',
                allowOutsideClick: false,
                allowEscapeKey: false,
                className: 'swal-wide',
            });
        },

        async obtener_datos_empleado(){
            try{
                let response = await this.$http.get("apoyos-escolares/get-datos_empleado/"+this.user.id_empleado);
                this.datos_empleado = response.data.data;

            }catch(error){
                this.showAlert = true;
            }
        },

    }

}
</script>

<style>
.apoyos-escolares-page {
    min-height: calc(100vh - 110px);
}

.apoyos-escolares-loading {
    min-height: calc(100vh - 260px);
}

.notification-badge {
    background-color: red;
    color: white;
    border-radius: 55%;
    padding: 8px 12px; /* Ajustado para el doble de tamaño */
    font-size: 14px; /* Ajustado para el doble de tamaño */
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 1030px; /* Margen a la izquierda para separar del icono */
    margin-top: -30px;
}

/* Estilos para el contenedor */
.swal-wide {
    width: 650px !important;
    max-width: 80%;
}

/* Estilos para los botones */
.swal-cancel-button {
    background-color: #f44336 !important;
    color: white !important;
}

.swal-confirm-button {
    background-color: #4CAF50 !important;
    color: white !important;
}

/* Alineación del contenido */
.swal-content {
    text-align: left !important;
    padding: 0 1em !important;
}

.file-dropbox {
  width: 100%;
}

.upload-zone {
  min-height: 150px;
  border: 2px dashed #ccc;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.active-dropzone {
  border-color: #1976d2;
  background-color: rgba(25, 118, 210, 0.05);
}

.has-files {
  min-height: auto;
  justify-content: flex-start;
  align-items: stretch;
}

.file-list {
  width: 100%;
}

/* Estilo para cuando está deshabilitado en modo "ver" */
.upload-zone[disabled] {
  opacity: 0.7;
  cursor: default;
}
</style>
